import * as filestack from 'filestack-js';

let client: filestack.Client | null = null;
try {
  client = filestack.init(process.env.FILESTACK_API_KEY);
} catch {
  // Filestack requires a valid API key. In E2E/test environments with placeholder keys,
  // initialization fails. Upload functionality will be unavailable.
}

export const uploadToFilestack = (file: Blob, filename?: string) => {
  if (!client) {
    throw new Error('Filestack not initialized — file upload unavailable in E2E mode');
  }

  const uploadOptions: filestack.UploadOptions = {};
  const storageOptions: filestack.StoreUploadOptions = { filename };

  return client.upload(file, uploadOptions, storageOptions);
};
